import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const signApplication: TaskDefinition = {
  taskName: onboardingTasks.SignApplication,
  config: {
    staffDisplayName: 'Sign policy documents',
    appcuesModalId: '63249237-5e04-4437-a496-12ff76cd2648',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    autoApprove: true,
    eventName: 'Signed Application',
    account: {
      content: ({ affectedPolicies, daysAllowed }) => ({
        title: 'Sign your policy documents',
        incompleteSubtitle: 'Sign to keep your elected coverage.',
        completedSubtitle: `You have successfully signed your documents for ${affectedPolicies}.`,
        actionLabel: 'Sign Documents',
        contentSections: [
          {
            title: 'How do I sign my documents?',
            body: 'You can sign your documents online by following the above "Sign document" link. If for any reason you can\'t sign the document this way, please contact us.'
          },
          {
            title: 'When do I need to submit these documents?',
            body: `You have ${daysAllowed} days to sign your policy documents. Without your signature, we may have to revert you back to state-recommended coverage, and the price of your policy may increase.`
          }
        ]
      })
    }
  }
};
